import { createContext } from "react";
import emptyFunction from "fbjs/lib/emptyFunction";

type defaultFunction = (giftId: string, categoryName?: string) => void;

export default createContext({
  giftSetRenderPosition: emptyFunction as defaultFunction,
  giftGetRenderPosition: emptyFunction as defaultFunction,
});
